// client/src/components/marketer/project/modals/CompleteModal.js
import React from 'react';
import '../../../../styles/marketer/modals/ContractModals.css';

export default function CompleteModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="complete-modal mbm-overlay" onClick={onClose}>
      <div className="complete-modal__content mbm" onClick={(e) => e.stopPropagation()}>
        {/* 로고 */}
        <div className="complete-modal__logo">
          <span className="complete-modal__logo-s">S</span>
          <span className="complete-modal__logo-ad">Ad</span>
        </div>

        {/* 메시지 */}
        <h2 className="complete-modal__title mbm-title">계약 요청이 완료되었습니다. (Contract request sent.)</h2>
        <p className="complete-modal__message">
          진행중인 프로젝트 보기 및, 결과를 송인하기에서<br />
          프로젝트를 관리하세요. (Manage the project in Ongoing Projects and Review Deliverables.)
        </p>

        {/* 확인 버튼 */}
        <div className="mbm-foot">
          <button className="mb-btn mb-btn-primary" onClick={onClose}>
            확인 (OK)
          </button>
        </div>
      </div>
    </div>
  );
}
